<div class='mte-main' data-cy="teeth-mte-container">
  <mat-progress-spinner *ngIf="isLoading" style="margin-left: auto; margin-right: auto; position: relative; top: 50%; transform: translateY(-50%)" diameter="100" mode="indeterminate" data-cy="teeth-mte-loading-spinner"></mat-progress-spinner>
  <mat-grid-list *ngIf="!isLoading" cols="6" rowHeight="100%" style="height:100%;" data-cy="teeth-mte-grid">
    <mat-grid-tile colspan="2" data-cy="teeth-mte-list-tile">
      <mat-card appearance="outlined" style="width:100%; height: calc(100%); display: flex; flex-direction: column;" data-cy="teeth-mte-list-card">
        <span class="configuration-section-title" data-cy="teeth-mte-list-title">Multi Tooth Autofill </span>
        <div style="flex: 1; max-height: 100%; overflow-y: hidden;" data-cy="teeth-mte-list-content">

          <dx-list
            [dataSource]="configs"
            keyExpr="AutoFillID"
            selectionMode="single"
            [(selectedItemKeys)]="selectedKeys"
            (selectedItemsChange)="onSelectionChanged($event)"
            data-cy="teeth-mte-list">

            <div *dxTemplate="let item of 'item'" data-cy="teeth-mte-item-template">
              <div *ngIf="item.xauditDeleted===false" data-cy="teeth-mte-item-{{item.AutoFillID}}">{{ item.AutofillName }}
                <div style="float: right"><dx-button icon="close" (onClick)="onDeleted( item)" data-cy="teeth-mte-delete-button-{{item.AutoFillID}}"></dx-button></div>
              </div>
              <div *ngIf="item.xauditDeleted===true" style="text-decoration: line-through;" data-cy="teeth-mte-deleted-item-{{item.AutoFillID}}">{{ item.AutofillName }}</div>
            </div>

            <dxo-item-dragging
              group="mti"
              [data]="configs"
              [allowReordering]="true"
              [onDragStart]="onTDragStart"
              [onAdd]="onTAdd"
              [onRemove]="onTRemove"
              [onReorder]="onTReorder"
              data-cy="teeth-mte-drag-drop">
            </dxo-item-dragging>
          </dx-list>
        </div>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile *ngIf="!isLoading" colspan="4" data-cy="teeth-mte-detail-tile">
      <mat-card appearance="outlined" style="width:100%;height:100%" data-cy="teeth-mte-detail-card">
        <mat-card-content data-cy="teeth-mte-detail-content">
          <div style="max-width: 700px;" data-cy="teeth-mte-detail-container">
            <div data-cy="teeth-mte-detail-header">
                <span class="configuration-section-title" data-cy="teeth-mte-detail-title">Autofill Configuration</span>
            </div>
            <div style="margin-bottom: 5px;" data-cy="teeth-mte-action-buttons">
              <dx-button text="New" [disabled]="isDataChanged" (onClick)="onNew($event)" data-cy="teeth-mte-new-button"></dx-button>
              <dx-button text="Save" [disabled]="!isDataChanged" (onClick)="onSaveZ()" data-cy="teeth-mte-save-button"></dx-button>
            </div>
            <div style="display: flex;" data-cy="teeth-mte-name-container">
              <div style="margin-right: 4px; text-align: right;" data-cy="teeth-mte-name-label">Name:</div>

              <div style="flex-basis: 200px; height: 24px; margin-right: 4px; border: 1px solid var(--tdo-primary); border-radius: 4px; padding: 1px;" data-cy="teeth-mte-name-input-container">
                <input style="width: 100%; height: 100%; border: unset; outline: unset; padding: 2px;" (change)="onTextChange()" (appInputFinished)="onNameInputFinished($event);" [value]="selectedConfig?.AutofillName" data-cy="teeth-mte-name-input" />
              </div>

              <mat-checkbox labelPosition="before" [checked]="selectedConfig?.isVital" (change)="onVitalChange($event);" data-cy="teeth-mte-vital-checkbox">Vital: </mat-checkbox>
            </div>
            <div class="mti-teeth"
                 style="width: 100%; max-width: 100%; padding: 4px; display: flex; max-height: 100%; overflow-y: auto; overflow-x: hidden;"
                 data-cy="teeth-mte-form-container">
              <div style="flex-basis: 130px; min-width: 130px; display: flex; flex-direction: column;" data-cy="teeth-mte-labels-column">
                <!--LABELS-->
                <div class="mti-label mti-light" data-cy="teeth-mte-label-chief-complaint">Chief Complaint:</div>
                <div class="mti-label mti-dark" data-cy="teeth-mte-label-palpitation">Palpitation:</div>
                <div class="mti-label mti-light" data-cy="teeth-mte-label-percussion">Percussion:</div>
                <div class="mti-label mti-dark" data-cy="teeth-mte-label-mobility">Mobility:</div>
                <div class="mti-label mti-light" data-cy="teeth-mte-label-bite">Bite:</div>
                <div class="mti-label mti-dark" data-cy="teeth-mte-label-chewing">Chewing:</div>
                <div class="mti-label mti-light" data-cy="teeth-mte-label-air">Air:</div>
                <div class="mti-label mti-cold" data-cy="teeth-mte-label-cold">Cold:</div>
                <div class="mti-label mti-hot" data-cy="teeth-mte-label-hot">Hot:</div>
                <div class="mti-label mti-dark" data-cy="teeth-mte-label-ept">EPT:</div>
                <div class="mti-label mti-light" data-cy="teeth-mte-label-sinus-track">Sinus Track:</div>
                <div class="mti-label mti-dark" data-cy="teeth-mte-label-occusal-trauma">Occusal Trauma:</div>
                <div class="mti-label mti-light" data-cy="teeth-mte-label-fracture">Fracture:</div>
                <div class="mti-label mti-hot" data-cy="teeth-mte-label-pulp-diag">Pulp Diag:</div>
                <div class="mti-label mti-light-green" data-cy="teeth-mte-label-periapical-diag">Periapical Diag:</div>
                <div class="mti-label mti-dark-green" data-cy="teeth-mte-label-endo-prognosis">Endo Prognosis:</div>
                <div class="mti-label mti-light-blue" data-cy="teeth-mte-label-perio-prognosis">Perio Prognosis:</div>
                <div class="mti-label mti-dark" data-cy="teeth-mte-label-restorative-prognosis">Restorative Prognosis:</div>
                <div class="mti-label mti-light" data-cy="teeth-mte-label-recommended-tx">Recommended Tx:</div>
                <div class="mti-label mti-dark" data-cy="teeth-mte-label-after-recommended-tx">After Recommended Tx:</div>
                <div class="mti-label mti-light" data-cy="teeth-mte-label-third-recommended-tx">3rd Recommended Tx:</div>
                <div class="mti-label mti-dark" data-cy="teeth-mte-label-treatment-order">Treatment Order:</div>
                <div class="mti-label mti-light" data-cy="teeth-mte-label-estimated-visits">Estimated # of Visits:</div>
                <div style="display: flex; flex-direction: column;" data-cy="teeth-mte-label-additional-container">
                  <div class="mti-label mti-light" data-cy="teeth-mte-label-vital-test-cavity">Vital Test Cavity:</div>
                  <div class="mti-label mti-dark" data-cy="teeth-mte-label-sweets">Sweets:</div>
                  <div class="mti-label mti-light" data-cy="teeth-mte-label-flossing">Flossing:</div>
                  <div class="mti-label mti-dark" data-cy="teeth-mte-label-lying-down">Lying Down:</div>
                  <div class="mti-label mti-light" data-cy="teeth-mte-label-exercise-bp">Excercise BP:</div>
                  <div class="mti-label mti-dark" data-cy="teeth-mte-label-head-position">Head Position:</div>
                  <div class="mti-label mti-light" data-cy="teeth-mte-label-cervical-sensitivity">Cervical Sensitivity:</div>
                  <div class="mti-label mti-dark" data-cy="teeth-mte-label-b-lateral-force">B Lateral Force:</div>
                  <div class="mti-label mti-light" data-cy="teeth-mte-label-l-lateral-force">L Lateral Force:</div>
                  <div class="mti-label" data-cy="teeth-mte-label-spacer"></div>
                </div>
              </div>
              <!--INPUTS-->
              <div style="flex-basis: 1px;" data-cy="teeth-mte-spacer"></div>
              <div style="flex: 1; height: fit-content; display: flex; overflow-x: hidden;" data-cy="teeth-mte-input-container">
                <div style="max-width: 100%; width: 100%; overflow-x: auto; display: flex;" data-cy="teeth-mte-input-scroll-container">
                  <div style="width: 100%; height: 300px; font-size: 16px; color: var(--tdo-primary); text-align: center;" *ngIf="configs.length === 0" data-cy="teeth-mte-empty-state">
                    <div (click)="onNew(null)" style="font-weight: 500; cursor: pointer; position: relative; top: 200px;" data-cy="teeth-mte-empty-new-button">
                      Click here to add your first autofill <mat-icon style="position: relative; top: 6px;">add_circle_outline</mat-icon>
                    </div>
                  </div>
                  <div *ngIf="selectedConfig"
                       style="flex-basis: 130px; min-width: 130px; margin-left: 1px; display: flex; flex-direction: column;"
                       data-cy="teeth-mte-enums-container">
                    <!--ENUM SELECTS-->
                    <div class="mti-label mti-dark-grey" data-cy="teeth-mte-chief-complaint-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTEChiefComplaintID"
                        (enumSelected)="selectedConfig.enumMTEChiefComplaintID = $event.ValidValueItemId; onSave();"
                        name="enumMTEChiefComplaint" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-chief-complaint-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label mti-light-grey" data-cy="teeth-mte-palpation-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTEPalpationID"
                        (enumSelected)="selectedConfig.enumMTEPalpationID = $event.ValidValueItemId; onSave();"
                        name="enumMTEPalpation" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-palpation-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label mti-dark-grey" data-cy="teeth-mte-percussion-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTEPercussionID"
                        (enumSelected)="selectedConfig.enumMTEPercussionID = $event.ValidValueItemId; onSave();"
                        name="enumMTEPercussion" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-percussion-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label mti-light-grey" data-cy="teeth-mte-mobility-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTEMobilityID"
                        (enumSelected)="selectedConfig.enumMTEMobilityID = $event.ValidValueItemId; onSave();"
                        name="enumMTEMobility" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-mobility-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label mti-dark-grey" data-cy="teeth-mte-bite-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTEBiteID"
                        (enumSelected)="selectedConfig.enumMTEBiteID = $event.ValidValueItemId; onSave();"
                        name="enumMTEBite" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-bite-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label mti-light-grey" data-cy="teeth-mte-chewing-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTEChewingID"
                        (enumSelected)="selectedConfig.enumMTEChewingID = $event.ValidValueItemId; onSave();"
                        name="enumMTEChewing" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-chewing-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label mti-dark-grey" data-cy="teeth-mte-air-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTEAirID"
                        (enumSelected)="selectedConfig.enumMTEAirID = $event.ValidValueItemId; onSave();"
                        name="enumMTEAir" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-air-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label" style="background-color: #a9a9ff;" data-cy="teeth-mte-cold-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTEColdID"
                        (enumSelected)="selectedConfig.enumMTEColdID = $event.ValidValueItemId; onSave();"
                        name="enumMTECold" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-cold-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label" style="background-color: #ffb5b5;" data-cy="teeth-mte-hot-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTEHotID"
                        (enumSelected)="selectedConfig.enumMTEHotID = $event.ValidValueItemId; onSave();"
                        name="enumMTEHot" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-hot-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label mti-light-grey" data-cy="teeth-mte-ept-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTEeptID"
                        (enumSelected)="selectedConfig.enumMTEeptID = $event.ValidValueItemId; onSave();"
                        name="enumMTEept" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-ept-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label mti-dark-grey" data-cy="teeth-mte-sinus-track-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTESinusTrackID"
                        (enumSelected)="selectedConfig.enumMTESinusTrackID = $event.ValidValueItemId; onSave();"
                        name="enumMTESinusTrack" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-sinus-track-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label mti-light-grey" data-cy="teeth-mte-occusal-trauma-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTEOccusalTraumaID"
                        (enumSelected)="selectedConfig.enumMTEOccusalTraumaID = $event.ValidValueItemId; onSave();"
                        name="enumMTEOccusalTrauma" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-occusal-trauma-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label mti-dark-grey" data-cy="teeth-mte-fracture-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTEFractureID"
                        (enumSelected)="selectedConfig.enumMTEFractureID = $event.ValidValueItemId; onSave();"
                        name="enumMTEFracture" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-fracture-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label mti-light-grey" data-cy="teeth-mte-pulp-diag-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTEPulpDiagID"
                        (enumSelected)="selectedConfig.enumMTEPulpDiagID = $event.ValidValueItemId; onSave();"
                        name="enumMTEPulpDiag" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-pulp-diag-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label mti-dark-grey" data-cy="teeth-mte-per-diag-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTEPerDiagID"
                        (enumSelected)="selectedConfig.enumMTEPerDiagID = $event.ValidValueItemId; onSave();"
                        name="enumMTEPerDiag" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-per-diag-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label mti-light-grey" data-cy="teeth-mte-endo-prognosis-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTEEndoPrognosisID"
                        (enumSelected)="selectedConfig.enumMTEEndoPrognosisID = $event.ValidValueItemId; onSave();"
                        name="enumMTEEndoPrognosis" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-endo-prognosis-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label mti-dark-grey" data-cy="teeth-mte-perio-prognosis-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTEPerioPrognosisID"
                        (enumSelected)="selectedConfig.enumMTEPerioPrognosisID = $event.ValidValueItemId; onSave();"
                        name="enumMTEPerioPrognosis" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-perio-prognosis-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label mti-light-grey" data-cy="teeth-mte-restorative-prognosis-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTERestorPrognosisID"
                        (enumSelected)="selectedConfig.enumMTERestorPrognosisID = $event.ValidValueItemId; onSave();"
                        name="enumMTERestorPrognosis" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-restorative-prognosis-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label mti-dark-grey" data-cy="teeth-mte-recommended-tx-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTERecomendedTxID"
                        (enumSelected)="selectedConfig.enumMTERecomendedTxID = $event.ValidValueItemId; onSave();"
                        name="enumMTERecomendedTx" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-recommended-tx-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label mti-light-grey" data-cy="teeth-mte-recommended-tx-after-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTERecomendedTx_AfterID"
                        (enumSelected)="selectedConfig.enumMTERecomendedTx_AfterID = $event.ValidValueItemId; onSave();"
                        name="enumMTERecomendedTx" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-recommended-tx-after-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label mti-dark-grey" data-cy="teeth-mte-recommended-tx-third-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTERecomendedTx_ThirdID"
                        (enumSelected)="selectedConfig.enumMTERecomendedTx_ThirdID = $event.ValidValueItemId; onSave();"
                        name="enumMTERecomendedTx" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-recommended-tx-third-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label mti-light-grey" data-cy="teeth-mte-treatment-order-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTETretmentOrderID"
                        (enumSelected)="selectedConfig.enumMTETretmentOrderID = $event.ValidValueItemId; onSave();"
                        name="enumMTETretmentOrder" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-treatment-order-select"></app-tdo-enum-select>
                    </div>
                    <div class="mti-label mti-dark-grey" data-cy="teeth-mte-estimated-visits-container">
                      <app-tdo-enum-select allowReset="true"
                        [validValueItemId]="selectedConfig.enumMTENumberOfVisitsID"
                        (enumSelected)="selectedConfig.enumMTENumberOfVisitsID = $event.ValidValueItemId; onSave();"
                        name="enumMTENumberOfVisits" style="position: relative; top: -2px;"
                        data-cy="teeth-mte-estimated-visits-select"></app-tdo-enum-select>
                    </div>
                    <div style="display: flex; flex-direction: column;" data-cy="teeth-mte-vital-test-cavity-container">
                      <div class="mti-label mti-light-grey" data-cy="teeth-mte-vital-test-cavity-select">
                        <app-tdo-enum-select allowReset="true"
                          [validValueItemId]="selectedConfig.enumMTEVitalTestCavityID"
                          (enumSelected)="selectedConfig.enumMTEVitalTestCavityID = $event.ValidValueItemId; onSave();"
                          name="enumMTEVitalTestCavity" style="position: relative; top: -2px;"
                          data-cy="teeth-mte-vital-test-cavity-select"></app-tdo-enum-select>
                      </div>
                      <div class="mti-label mti-dark-grey" data-cy="teeth-mte-sweets-container">
                        <app-tdo-enum-select allowReset="true"
                          [validValueItemId]="selectedConfig.enumMTESweetsID"
                          (enumSelected)="selectedConfig.enumMTESweetsID = $event.ValidValueItemId; onSave();"
                          name="enumMTESweets" style="position: relative; top: -2px;"
                          data-cy="teeth-mte-sweets-select"></app-tdo-enum-select>
                      </div>
                      <div class="mti-label mti-light-grey" data-cy="teeth-mte-flossing-container">
                        <app-tdo-enum-select allowReset="true"
                          [validValueItemId]="selectedConfig.enumMTEFlossingID"
                          (enumSelected)="selectedConfig.enumMTEFlossingID = $event.ValidValueItemId; onSave();"
                          name="enumMTEFlossing" style="position: relative; top: -2px;"
                          data-cy="teeth-mte-flossing-select"></app-tdo-enum-select>
                      </div>
                      <div class="mti-label mti-dark-grey" data-cy="teeth-mte-lying-down-container">
                        <app-tdo-enum-select allowReset="true"
                          [validValueItemId]="selectedConfig.enumMTELayingDownID"
                          (enumSelected)="selectedConfig.enumMTELayingDownID = $event.ValidValueItemId; onSave();"
                          name="enumMTELayingDown" style="position: relative; top: -2px;"
                          data-cy="teeth-mte-lying-down-select"></app-tdo-enum-select>
                      </div>
                      <div class="mti-label mti-light-grey" data-cy="teeth-mte-exercise-bp-container">
                        <app-tdo-enum-select allowReset="true"
                          [validValueItemId]="selectedConfig.enumMTEExersiseBPID"
                          (enumSelected)="selectedConfig.enumMTEExersiseBPID = $event.ValidValueItemId; onSave();"
                          name="enumMTEExersiseBP" style="position: relative; top: -2px;"
                          data-cy="teeth-mte-exercise-bp-select"></app-tdo-enum-select>
                      </div>
                      <div class="mti-label mti-dark-grey" data-cy="teeth-mte-head-position-container">
                        <app-tdo-enum-select allowReset="true"
                          [validValueItemId]="selectedConfig.enumMTEHeadPosistionID"
                          (enumSelected)="selectedConfig.enumMTEHeadPosistionID = $event.ValidValueItemId; onSave();"
                          name="enumMTEHeadPosistion" style="position: relative; top: -2px;"
                          data-cy="teeth-mte-head-position-select"></app-tdo-enum-select>
                      </div>
                      <div class="mti-label mti-light-grey" data-cy="teeth-mte-cervical-sensitivity-container">
                        <app-tdo-enum-select allowReset="true"
                          [validValueItemId]="selectedConfig.enumMTECervicalSensID"
                          (enumSelected)="selectedConfig.enumMTECervicalSensID = $event.ValidValueItemId; onSave();"
                          name="enumMTECervicalSens" style="position: relative; top: -2px;"
                          data-cy="teeth-mte-cervical-sensitivity-select"></app-tdo-enum-select>
                      </div>
                      <div class="mti-label mti-dark-grey" data-cy="teeth-mte-b-lateral-force-container">
                        <app-tdo-enum-select allowReset="true"
                          [validValueItemId]="selectedConfig.enumMTEBLateralForceID"
                          (enumSelected)="selectedConfig.enumMTEBLateralForceID = $event.ValidValueItemId; onSave();"
                          name="enumMTEBLateralForce" style="position: relative; top: -2px;"
                          data-cy="teeth-mte-b-lateral-force-select"></app-tdo-enum-select>
                      </div>
                      <div class="mti-label mti-light-grey" data-cy="teeth-mte-l-lateral-force-container">
                        <app-tdo-enum-select allowReset="true"
                          [validValueItemId]="selectedConfig.enumMTELLateralForceID"
                          (enumSelected)="selectedConfig.enumMTELLateralForceID = $event.ValidValueItemId; onSave();"
                          name="enumMTELLateralForce" style="position: relative; top: -2px;"
                          data-cy="teeth-mte-l-lateral-force-select"></app-tdo-enum-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>
